import * as React from "react";
import {
  Button,
  Grid,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper as MuiPaper,
  MenuItem,
  Select,
  CircularProgress,
  Checkbox,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import Link from "@mui/material/Link";
import { NavLink, useNavigate } from "react-router-dom";
import { Box, spacing } from "@mui/system";
import styled from "@emotion/styled";
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import { useEffect } from "react";
import PropTypes from "prop-types";

export default function CreateCyclePaymentComponent({createCompoment}) {
  let { getApi, postApi, user, signUpStep2, isBSAccount, isInitializedBS } =
    useAuth();
  const [tabVal, setTabVal] = React.useState(0);

 let { 
    setCycleType,
cycletype,
setInstallments,
installments,
due_date,
setDueDate,
applyAmountFirstInstallment,
amountFirstInstallment,
setApplyAmountFirstInstallment,
setValorFirstAmount
  } = createCompoment;
  

  return (
    <React.Fragment>
    <Grid container spacing={6}>
              <Grid item md={4}>
                  <FormControl sx={{ m: 1, width: '25ch' }}  >
                    <InputLabel id="demo-simple-select-label">Ciclo de pagamento</InputLabel>
                      <Select fullWidth required
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Parcelas do carnê"
                        onChange={e=> setCycleType(e.target.value)}
                        value={cycletype}
                      >
                        <MenuItem value={1}>Mensal</MenuItem>
                        <MenuItem value={2}>Semanal</MenuItem>
                        <MenuItem value={3}>Quinzenal</MenuItem>
                        <MenuItem value={4}>Trimensal</MenuItem>
                        <MenuItem value={5}>Semestral</MenuItem>
                        <MenuItem value={6}>Anual</MenuItem>
                      </Select>
                  </FormControl>
                </Grid>



                <Grid item md={4}>
                  <FormControl sx={{ m: 1, width: '25ch' }}  >
                    <InputLabel id="demo-simple-select-label">Parcelas do carnê</InputLabel>
                      <Select fullWidth required
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Parcelas do carnê"
                        onChange={e=> setInstallments(e.target.value)}
                        value={installments}
                      >
                        <MenuItem value={2}>2 parcelas</MenuItem>
                        <MenuItem value={3}>3 parcelas</MenuItem>
                        <MenuItem value={4}>4 parcelas</MenuItem>
                        <MenuItem value={5}>5 parcelas</MenuItem>
                        <MenuItem value={6}>6 parcelas</MenuItem>
                        <MenuItem value={7}>7 parcelas</MenuItem>
                        <MenuItem value={8}>8 parcelas</MenuItem>
                        <MenuItem value={9}>9 parcelas</MenuItem>
                        <MenuItem value={10}>10 parcelas</MenuItem>
                        <MenuItem value={11}>11 parcelas</MenuItem>
                        <MenuItem value={12}>12 parcelas</MenuItem>
                        <MenuItem value={13}>13 parcelas</MenuItem>
                        <MenuItem value={14}>14 parcelas</MenuItem>
                        <MenuItem value={15}>15 parcelas</MenuItem>
                        <MenuItem value={16}>16 parcelas</MenuItem>
                        <MenuItem value={17}>17 parcelas</MenuItem>
                        <MenuItem value={18}>18 parcelas</MenuItem>
                        <MenuItem value={19}>19 parcelas</MenuItem>
                        <MenuItem value={20}>20 parcelas</MenuItem>
                        <MenuItem value={21}>21 parcelas</MenuItem>
                        <MenuItem value={22}>22 parcelas</MenuItem>
                        <MenuItem value={23}>23 parcelas</MenuItem>
                        <MenuItem value={24}>24 parcelas</MenuItem>
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item md={6}>
                <LocalizationProvider locale={ptBR} dateAdapter={AdapterDateFns}>
                  <MobileDatePicker
                    label="Data de Vencimento"
                    inputFormat="dd/MM/yyyy"
                    onChange={setDueDate}
                    value={due_date}
                    minDate={new Date()}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  
                </LocalizationProvider>
                </Grid>
               
              </Grid>

              <Grid container spacing={4} mt={1}>
                <Grid item md={4}>
                  <FormControlLabel
                    control={
                      <Switch
                      checked={applyAmountFirstInstallment}
                      onChange={e=> setApplyAmountFirstInstallment(!applyAmountFirstInstallment)}
                        name="gilad"
                      />
                    }
                    label="Definir valor da 1º parcela"
                  />
                </Grid>
                {applyAmountFirstInstallment &&
                <Grid item md={4}>
                  <FormControl  variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-amount">Valor da 1º Parcela</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      endAdornment={<InputAdornment position="end">reais</InputAdornment>}
                      label="Valor 1º Parcela"
                      type={'number'}
                      step={0.01}
                      min={1}
                      onChange={e=> setValorFirstAmount(e.target.value)}
                      value={parseFloat(amountFirstInstallment).toFixed(2)}
                    />
                  </FormControl>
                </Grid>
                }

                
                
              </Grid>
    </React.Fragment>
  );
}

